
import { SnackbarProgrammatic as Snackbar } from 'buefy'
import API from '@/api'
import router from '@/router'
import {
  downloadBase64File
} from '@/utils/helpers'

const actions = {
  getOrder({ dispatch, commit, state }, orderId) {
    commit('setIsLoading', true)

    API.orders.getOrder(orderId)
      .then(({ data: { data, include } }) => {
        commit('setOrder', data)
        commit('setBookingsIds', data)
        commit('setInclude', include)
        commit('setFeedbackForm', data.feedback)

        commit('setIsLoading', false)

        if (data.feedback.rating !== 0) {
          commit('setFeedbackFields', {
            showForm: false
          })
        }

        state.bookingsIds.forEach((item) => {
          dispatch('getPenalties', item)
        })
      })
      .catch(() => {
        commit('setIsLoadingError', true)
      })
  },
  getPenalties({ commit }, { id: bookingId, name: serviceName }) {
    API.orders.getPenalties({ bookingId })
      .then(({ data: { data: { results } } }) => {
        if (results.length === 0) {
          commit('setAllBookingsPenalties', {
            bookingId,
            penalties: {
              collection: [],
              hasError: true,
              errors: [{ detail: 'Невозможно загрузить штрафы!' }],
              label: serviceName
            }
          })
        } else {
          commit('setAllBookingsPenalties', {
            bookingId,
            penalties: {
              collection: [...results],
              hasError: false,
              errors: [],
              label: serviceName
            }
          })
        }
      })
      .catch(({ data: { errors } }) => {
        commit('setAllBookingsPenalties', {
          bookingId,
          penalties: {
            collection: [],
            hasError: true,
            errors,
            label: serviceName
          }
        })
      })
  },
  booking({ commit }, payload) {
    API.cart.booking(payload)
      .then(() => {
        commit('changeBookingLoadingStatus', false)

        router.go()
      })
      .catch(() => {
        commit('changeBookingLoadingStatus', false)
      })
  },
  sendFeedback({ commit, }, { id, form }) {
    API.orders.sendFeedback(id, form)
      .then(() => {
        commit('setFeedbackFields', {
          isLoading: false,
          isSended: true,
          showSendingMessage: true
        })

        setTimeout(() => {
          commit('setFeedbackFields', {
            showSendingMessage: false,
            showForm: false
          })
        }, 2000)
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Отзыв не был отправлен.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
  },
  editFeedback({ commit }, { id, form }) {
    API.orders.updateFeedback(id, form)
      .then(() => {
        commit('setFeedbackFields', {
          isLoading: false,
          isSended: true,
          showEditMessage: true
        })

        setTimeout(() => {
          commit('setFeedbackFields', {
            showEditMessage: false,
            showEditForm: false,
          })
        }, 2000)
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Обновленный отзыв не был отправлен.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
  },
  getMessages({ commit, rootState }, payload) {
    API.orders.getMessages(payload)
      .then(({ data: { data: { messages } } }) => {
        commit('setMessages', {
          messages,
          userId: rootState.profile.user.id
        })
      })
      .catch(() => {
        commit('setChat', {
          isBlocked: true
        })
      })
      .finally(() => {
        commit('setChat', {
          isLoading: false,
        })
      })
  },
  sendMessage({ commit, rootState }, payload) {
    API.orders.sendMessage(payload)
      .then(({ data: { data: { message } } }) => {
        commit('addMessage', {
          message,
          userId: rootState.profile.user.id
        })
      })
      .catch(({ data: { errors } }) => {
        commit('setChatError', errors)
      })
      .finally(() => {
        commit('setChat', {
          isLoading: false,
          form: {
            message: ''
          }
        })
      })
  },
  sendDocument({ commit }, { bookingId, email }) {
    API.orders.sendDocument(bookingId, { email })
      .then(() => {
        Snackbar.open({
          duration: 5000,
          message: `<span>Успешно</span>Документ успешно отправлен по адресу ${email}.`,
          position: 'is-top-right',
          type: 'is-success'
        })
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Документ не был отправлен.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
      .finally(() => {
        commit('updateDocumentsLoading', {
          isDownloading: false,
          isSending: false
        })
      })
  },
  downloadDocument({ commit }, { bookingId, name }) {
    API.orders.downloadDocument(bookingId)
      .then(({ data: { data: { voucher } } }) => {
        downloadBase64File(voucher, `${name}.pdf`)
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Не удалось скачать документ.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
      .finally(() => {
        commit('updateDocumentsLoading', {
          isDownloading: false,
          isSending: false
        })
      })
  },
  downloadAllDocuments({ commit }, orderId) {
    API.orders.downloadAllDocuments(orderId)
      .then(({ data: { data: { voucher } } }) => {
        downloadBase64File(voucher, `Документы_заказа_${orderId}.pdf`)
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Не удалось скачать документы.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
      .finally(() => {
        commit('updateDocumentsLoading', {
          isDownloadingAll: false
        })
      })
  }
}

export default actions